module.exports = __webpack_public_path__ + "img/md_flow01.fdaef995.png";